import React from 'react';

interface ListSkeletonProps {
  /** Number of items to show */
  items?: number;
  /** Custom className */
  className?: string;
}

/**
 * Skeleton component for list items
 * Used in simple lists, notifications, etc.
 */
export const ListSkeleton: React.FC<ListSkeletonProps> = ({
  items = 5,
  className = '',
}) => {
  return (
    <div className={`animate-pulse space-y-3 ${className}`}>
      {[...Array(items)].map((_, i) => (
        <div key={i} className="flex items-center gap-4 py-3">
          <div className="h-10 w-10 rounded-full bg-gray-100 flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-4 w-3/4 rounded-lg bg-gray-100" />
            <div className="h-3 w-1/2 rounded-lg bg-gray-100" />
          </div>
        </div>
      ))}
    </div>
  );
};

